import { render, staticRenderFns } from "./ContactFormDialog.vue?vue&type=template&id=f163f944"
import script from "./ContactFormDialog.vue?vue&type=script&lang=ts"
export * from "./ContactFormDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports